import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ServiceRepReferenceService extends BaseReferenceService {
  constructor() {
    super('ServiceRepReference');
  }
}
